import React from "react";
import { StoreFilesScreenComponent } from "../../../../Files/FilesScreenComponent";
import { StoreAllFilesComponent } from "../../../../Files/AllFilesComponent";

import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { UserLoggedInNavigatorScreenProps } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { WAFileMain } from "./WAFile";
import { HeaderButton } from "../../../../../components";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { onlyUnique } from "../../../../../utils";
import {
  WAFileNavigationProp,
  WAFileRouteProp,
  WAFileStackNavigator,
} from "./WAFileNavigationProp";

function WAFileSelect({
  navigation,
  route: { params },
}: {
  navigation: WAFileNavigationProp<"WAFileSelect">;
  route: WAFileRouteProp<"WAFileSelect">;
}) {
  return (
    <StoreFilesScreenComponent
      includeIntegrationFiles={false}
      onPressFile={async ({ fileId, fileType, fileName, url }) =>
        navigation.navigateDeprecated("WAFileMain", {
          ...params,
          fileIds: [...params.fileIds, fileId].filter(onlyUnique),
        })
      }
      setHeaderRight={(p) => {
        navigation.setOptions({
          headerRight: p,
        });
      }}
      modal
      onUploadedFiles={(fileIds) => {
        navigation.navigateDeprecated("WAFileMain", {
          ...params,
          fileIds: [...params.fileIds, ...fileIds].filter(onlyUnique),
        });
      }}
      onShowAllFiles={() => {
        navigation.navigateDeprecated("WAAllFileSelect", params);
      }}
    />
  );
}

function WAAllFileSelect({ navigation, route: { params } }: any) {
  return (
    <StoreAllFilesComponent
      includeIntegrationFiles={false}
      onPressFile={async ({ fileId, fileType, fileName, url }) => {
        navigation.navigateDeprecated("WAFileMain", {
          ...params,
          fileIds: [...(params.fileIds ?? []), fileId].filter(onlyUnique),
        });
      }}
    />
  );
}

export const WAFileStack = withWebModal(
  (props: UserLoggedInNavigatorScreenProps<"WidgetAddFile">) => {
    const intl_tokens = useIntlTokens();
    return (
      <WAFileStackNavigator.Navigator
        screenOptions={{
          headerShown: true,
        }}
      >
        <WAFileStackNavigator.Screen
          name="WAFileMain"
          component={WAFileMain}
          options={{
            title: intl_tokens.Files,
            headerLeft: () => (
              <HeaderButton type="BACK" onPress={props.navigation.goBack} />
            ),
          }}
          initialParams={{ ...props.route.params, fileIds: [] }}
        />
        <WAFileStackNavigator.Screen
          name="WAFileSelect"
          component={WAFileSelect}
          options={{
            title: intl_tokens.Files,
          }}
          initialParams={{ ...props.route.params, fileIds: [] }}
        />
        <WAFileStackNavigator.Screen
          name="WAAllFileSelect"
          component={WAAllFileSelect}
          options={{
            title: intl_tokens.Files,
          }}
          initialParams={{ ...props.route.params }}
        />
      </WAFileStackNavigator.Navigator>
    );
  },
  false
);
